@if (landingpageConfig(); as _landingpageConfig) {
  <ez-main-layout [landingpageConfig]="_landingpageConfig" [theme]="Themes.NONE">
    <ez-banner>
      <span ngProjectAs="title">Fertig!</span>
      <span ngProjectAs="subtitle">Zahlung abgeschlossen</span>
    </ez-banner>

    <div class="block--centered success-info">
      <span class="material-symbols-outlined icon-success" aria-hidden="true">check_circle</span>
      <p class="success-title">Vielen Dank für Ihre Zahlung</p>
    </div>

    <ez-contact
      [organisation]="_landingpageConfig.organisation"
      [customData]="_landingpageConfig.customData"
      teaser="{{
        _landingpageConfig.organisation.customFields['contactTeaser'] ||
          'Sie haben schon gezahlt oder möchten noch Fragen mit uns klären? Sie können nur einen Teil des Beitrags zahlen? <br> <br> Dann rufen Sie uns bitte an:'
      }}"
      subtitle="{{ _landingpageConfig.organisation.customFields['contactSubtitle'] }}"
      phonePrefix="{{ _landingpageConfig.organisation.customFields['contactPhonePrefix'] || 'Kundenservice: ' }}"
      withContactForm="false"
    ></ez-contact>
  </ez-main-layout>
}
